import React, { useEffect } from 'react';

import { ReactComponent as EditPencilIcon } from '../../../../assets/images/EditPencilIcon.svg';
import { sortYear } from '../../../../helpers/commonHelper';

import styles from './Education.module.scss';

const EducationDetails = ({ educationData, allowEdit, handleOpenModal }) => {
  useEffect(() => {
    if (educationData) {
      educationData.sort((data1, data2) => sortYear(data1.end_year, data2.end_year));
    }
  }, [educationData]);

  return educationData.map((data, counter) => {
    const { id, university, degree, field_study, start_year, end_year, description } = data;
    return (
      <div key={`${id}-edu`}>
        <div className={styles.jobTitle}>
          {university}
          {allowEdit && (
            <div>
              <button className={styles.addExperience} type="button" onClick={() => handleOpenModal(data)}>
                <EditPencilIcon />
              </button>
            </div>
          )}
        </div>
        <div className={styles.fadeText}>
          <div className="pb-1">{degree}</div>
          <div className="pb-1">{field_study}</div>
          <div>
            {start_year} to {end_year}
          </div>
        </div>
        <div className={styles.description}>{description}</div>
        {counter !== educationData.length - 1 && <div className={styles.endLine} />}
      </div>
    );
  });
};

export default EducationDetails;
